var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuxmodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.7936,
    y: 54.1143,
    width: 116,
    height: 117,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.684 75.4917C62.8753 59.1747 34.4416 36.1061 39.1101 26.2214C45.7455 12.1724 81.5394 15.6715 122.348 31.9885C163.156 48.3055 193.179 71.9945 186.89 85.3103C182.224 95.1958 144.494 91.8095 103.684 75.4917Z",
    stroke: "#FFD8A8",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6711 132.393V90.9761L118.754 111.684L86.6711 132.393Z",
    fill: "url(#paint0_linear_161_213)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_213",
    x1: 102.713,
    y1: 90.9761,
    x2: 102.713,
    y2: 132.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87CEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD8A8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuxmodLogo);
export default __webpack_public_path__ + "static/media/auxmod_logo.4fb44116b23c63fc52a06a3cf7aacd35.svg";
export { ForwardRef as ReactComponent };